export const CandidateDataTypes = {
    //TEXT
    FULL_NAME: 'CANDIDATE_FULL_NAME',
    FIRST_NAME: 'CANDIDATE_FIRST_NAME',
    LAST_NAME: 'CANDIDATE_LAST_NAME',
    EMAIL: 'CANDIDATE_EMAIL',
    PHONE: 'CANDIDATE_PHONE',
    VINCERE_EMERGENCY_PHONE: 'CANDIDATE_VINCERE_EMERGENCY_PHONE',
    ZIP_CODE: 'CANDIDATE_ZIP_CODE',
    ADDRESS: 'CANDIDATE_ADDRESS',
    JOB_TITLE: 'CANDIDATE_JOB_TITLE',
    DESIRED_JOB_TITLE: 'CANDIDATE_DESIRED_JOB_TITLE',
    CANDIDATE_IELTS_SCORE: 'CANDIDATE_IELTS_SCORE',
    CANDIDATE_VINCERE_NATIONALITY: 'CANDIDATE_VINCERE_NATIONALITY',
    //TEXT OR OPTIONS
    CITY: 'CANDIDATE_CITY',
    STATE: 'CANDIDATE_STATE',
    COUNTRY: 'CANDIDATE_COUNTRY',
    EDUCATION: 'CANDIDATE_EDUCATION',
    YEARS_EXPERIENCE: 'CANDIDATE_YEARS_EXPERIENCE',

    //OPTIONS
    STATUS: 'CANDIDATE_STATUS',
    TYPE: 'CANDIDATE_TYPE',
    DESIRED_JOB_TYPE: 'CANDIDATE_DESIRED_JOB_TYPE',

    //SALARY
    DESIRED_SALARY: 'CANDIDATE_DESIRED_SALARY',
    DESIRED_PAY_RATE: 'CANDIDATE_DESIRED_PAY_RATE',

    //DATE - Always Array
    BIRTHDAY: 'CANDIDATE_BIRTHDAY',
    AVAILABILITY: 'CANDIDATE_AVAILABILITY',

    //FILE - BASE64
    CV: 'CANDIDATE_CV',
    VISA: 'CANDIDATE_VISA',
    PASSPORT: 'CANDIDATE_PASSPORT',
    DRUG_TEST: 'CANDIDATE_DRUG_TEST',
    DRIVER_LICENCE: 'CANDIDATE_DRIVER_LICENCE',
    LINKEDIN : 'CANDIDATE_VINCERE_LINKEDIN',

    // VISA
    VISA_NOTE: 'CANDIDATE_VISA_NOTE',
    VISA_NUMBER: 'CANDIDATE_VISA_NUMBER',
    VISA_RENEWAL_DATE: 'CANDIDATE_VISA_RENEWAL_DATE',
    VISA_STATUS: 'CANDIDATE_VISA_STATUS',
    VISA_TYPE: 'CANDIDATE_VISA_TYPE',

    //TAG INPUT
    SKILLS: 'CANDIDATE_SKILLS',
};

export const JobDataTypes = {
    //TEXT (Can be numeric only)
    CLIENT_FIRST_NAME: 'JOB_CLIENT_FIRST_NAME',
    CLIENT_LAST_NAME: 'JOB_CLIENT_LAST_NAME',
    CLIENT_EMAIL: 'JOB_CLIENT_EMAIL',
    CLIENT_PHONE: 'JOB_CLIENT_PHONE',
    CLIENT_COMPANY_NAME: 'JOB_CLIENT_COMPANY_NAME',
    ADDRESS: 'JOB_ADDRESS',
    ZIP_CODE: 'JOB_ZIP_CODE',
    URL: 'JOB_URL',
    REQUIRED_YEARS: 'JOB_REQUIRED_YEARS',

    //TEXT (Can be numeric only) OR OPTIONS
    TITLE: 'JOB_TITLE',
    CITY: 'JOB_CITY',
    STATE: 'JOB_STATE',
    COUNTRY: 'JOB_COUNTRY',

    //OPTIONS
    TYPE: 'JOB_TYPE',

    //SALARY
    SALARY: 'JOB_SALARY',
    PAY_RATE: 'JOB_PAY_RATE',

    //DATE - Always Array
    JOB_START_DATE: 'JOB_START_DATE',
    JOB_END_DATE: 'JOB_END_DATE',
    CLIENT_AVAILABILITY: 'JOB_CLIENT_AVAILABILITY',

    //TAG INPUT
    SKILLS: 'JOB_SKILLS',
};

export const DataBlockDataTypes = {
    CANDIDATES: 'CANDIDATES',
    JOBS: 'JOBS',
};

export const UserDataTypes = {
    TYPE: 'USER_TYPE',
}
